module.exports = __webpack_public_path__ + "media/img/logos/2024/jobboerse-stellenangebote-berufseinsteiger-weihnachten-c1a592cb95de5158997fcdab25c52499.svg";